import type { Artist } from '../interfaces/maestra';
import { PAYWALL_DISABLED } from '../constants/maestra';

/**
 * O perfil está ATIVO? É a regra que substituiu o pagamento único, e há dois caminhos:
 *
 *   1. LEGADO — comprou o desbloqueio do perfil (ou ganhou um Pass Access). Vale para sempre,
 *      não depende de assinatura nenhuma e não ocupa vaga na cota. Quem pagou por um perfil não
 *      pode perdê-lo porque o modelo de cobrança mudou depois.
 *   2. ASSINATURA — a conta é PRO e o perfil cabe na cota de perfis contratada.
 *
 * Para o COLABORADOR, o PRO que conta é o do dono do perfil (`owner_is_pro`), não o dele: quem
 * paga a conta do perfil é quem convidou.
 */
export function perfilEstaAtivo(artist: Artist | null | undefined, isPro: boolean): boolean {
  if (PAYWALL_DISABLED) return true;
  if (!artist) return false;

  if (artist.legacy_unlocked === true) return true;

  const isOwner = artist.role !== 'member';
  const perfilTemPro = isOwner ? isPro : !!artist.owner_is_pro;

  // `!== 'suspended'` em vez de `=== 'active'`: a coluna nasce com default 'active', e um cliente
  // com dado antigo em cache traria `undefined`. Falhar para ATIVO aí é o certo — é o que o banco
  // diria — e evita tirar acesso de alguém por causa de cache velho.
  return perfilTemPro && artist.slot_state !== 'suspended';
}

/**
 * A assinatura vale como PRO agora? Ativa, ou em atraso ainda dentro da carência. É a mesma regra
 * do `useEntitlements` (que a usa), pura, para quem precisa dela sem o hook.
 */
export function assinaturaValeComoPro(status: string, gracePeriodEndsAt: string | null, now: number = Date.now()): boolean {
  if (PAYWALL_DISABLED) return true;
  return status === 'active'
    || (status === 'overdue' && gracePeriodEndsAt !== null && now <= new Date(gracePeriodEndsAt).getTime());
}
